export function getResponseContent<T>(response: any): T {
  return response?.data?.content ?? response?.content ?? response?.data ?? response;
}
